export default "__VITE_ASSET__BhxzFKcA__"